module.exports = __webpack_public_path__ + "static/media/MobileSteming.286a3471.png";